import { gql } from "@apollo/client";

export const ADD_CAMPAIGN = gql`
  mutation addCampaign(
    $name: String
    $audience_roles: [String!]!
    $end_ts: timestamptz!
    $frequency: String!
    $org_id: uuid
    $should_send_email: Boolean!
    $start_ts: timestamptz!
  ) {
    insert_campaign(
      objects: [
        {
          name: $name
          audience_roles: $audience_roles
          end_ts: $end_ts
          frequency: $frequency
          org_id: $org_id
          should_send_email: $should_send_email
          start_ts: $start_ts
        }
      ]
    ) {
      affected_rows
      returning {
        campaign_id
      }
    }
  }
`;

export const UPDATE_CAMPAIGN = gql`
  mutation updateCampaign(
    $campaign_id: uuid!
    $name: String
    $audience_roles: [String!]!
    $end_ts: timestamptz!
    $frequency: String!
    $should_send_email: Boolean!
    $start_ts: timestamptz!
  ) {
    update_campaign(
      where: { campaign_id: { _eq: $campaign_id } }
      _set: {
        name: $name
        audience_roles: $audience_roles
        end_ts: $end_ts
        frequency: $frequency
        should_send_email: $should_send_email
        start_ts: $start_ts
      }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_CAMPAIGN = gql`
  mutation deleteCampaign($campaign_id: uuid!) {
    delete_campaign(where: { campaign_id: { _eq: $campaign_id } }) {
      affected_rows
    }
  }
`;

export const ADD_CAMPAIGN_USERS = gql`
  mutation addCampaignUsers(
    $campaign_users: [campaign_user_insert_input!]!
  ) {
    insert_campaign_user(objects: $campaign_users) {
      affected_rows
    }
  }
`;

export const DELETE_CAMPAIGN_USERS = gql`
  mutation deleteCampaignUsers($campaign_id: uuid!) {
    delete_campaign_user(where: { campaign_id: { _eq: $campaign_id } }) {
      affected_rows
    }
  }
`;

export const ADD_CAMPAIGN_SURVEYS = gql`
  mutation addCampaignSurveys(
    $campaign_surveys: [campaign_survey_insert_input!]!
  ) {
    insert_campaign_survey(objects: $campaign_surveys) {
      affected_rows
    }
  }
`;

export const DELETE_CAMPAIGN_SURVEYS = gql`
  mutation deleteCampaignSurveys($campaign_id: uuid!) {
    delete_campaign_survey(where: { campaign_id: { _eq: $campaign_id } }) {
      affected_rows
    }
  }
`;
